export function getSuccessMessage(data) {
    let message;
    const notDocNumTypes = [
        "Sueldo",
        "Imposiciones",
        "Impuesto Único",
        "Rendición",
        "Boleta",
        "Boleta exenta",
    ];
    let hasDocNumber = !notDocNumTypes.includes(data.obligation_type.name);
    if (hasDocNumber) {
        message = `número <strong>${data.document_number}</strong>`;
    } else {
        message = `a nombre de <strong>${data.counterpart.name}</strong>`;
    }
    return message;
}
